<template>
  <div class="list">
    <CategoryItem
      v-for="item in list"
      :key="item.id"
      :item="item"
      :locale="locale"
      @delCategory="delCateogry"  />
  </div>
</template>

<script>
import CategoryItem from '@/components/Coupon/CategoryItem.vue'

export default {
  name: 'CategoryList',
  props: [
    'list',
    'locale'
  ],
  components: {
    CategoryItem
  },
  methods: {
    delCateogry (id) {
      this.$emit('delCategory', id)
    }
  }
}
</script>
